/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "@aws-amplify/ui-react/internal";
import IconBg from "./IconBg";
import { Flex, Text } from "@aws-amplify/ui-react";
export default function Title(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    {
      overrides: {
        IconBg: {},
        TitleWindow: {},
        "Frame 20799": {},
        Subtitle: {},
        Title: {},
      },
      variantValues: { subtitle: "true" },
    },
    {
      overrides: {
        IconBg: {},
        TitleWindow: {},
        "Frame 20799": {},
        Subtitle: { display: "none" },
        Title: {},
      },
      variantValues: { subtitle: "false" },
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Flex
      gap="8px"
      direction="column"
      width="unset"
      height="unset"
      justifyContent="flex-end"
      alignItems="flex-start"
      position="relative"
      padding="0px 0px 0px 0px"
      display="flex"
      {...getOverrideProps(overrides, "Title")}
      {...rest}
    >
      <Flex
        gap="36px"
        direction="row"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-end"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        display="flex"
        {...getOverrideProps(overrides, "Frame 20799")}
      >
        <IconBg
          display="flex"
          gap="10px"
          direction="row"
          width="62px"
          height="68.62px"
          justifyContent="center"
          alignItems="center"
          shrink="0"
          position="relative"
          boxShadow="2px 2px 4px rgba(0, 0, 0, 0.20999999344348907)"
          borderRadius="4px"
          padding="20px 20px 20px 20px"
          backgroundColor="rgba(242,97,95,1)"
          {...getOverrideProps(overrides, "IconBg")}
        ></IconBg>
        <Text
          fontFamily="Inter"
          fontSize="24px"
          fontWeight="400"
          color="rgba(13,26,38,1)"
          lineHeight="36px"
          textAlign="left"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Proceso de Crédito"
          {...getOverrideProps(overrides, "TitleWindow")}
        ></Text>
      </Flex>
      <Text
        fontFamily="Inter"
        fontSize="16px"
        fontWeight="400"
        color="rgba(174,179,183,1)"
        lineHeight="24px"
        textAlign="left"
        display="block"
        direction="column"
        justifyContent="unset"
        width="unset"
        height="unset"
        gap="unset"
        alignItems="unset"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="Asignación de verificador"
        {...getOverrideProps(overrides, "Subtitle")}
      ></Text>
    </Flex>
  );
}
